<template>
    <div>
        <v-chip color="purple" outlined small label
            style="position: fixed; top: 70px; right: 16px; z-index: 1000;">
            <v-icon left small>mdi-file-code-outline</v-icon>
            FormSubsidioMatrimonio.vue (matrimonio + unión)
        </v-chip>
        <DialogoComDistrito ref="dialogoCom" />
        <v-overlay :value="loading">
            <v-container fill-height fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="d-flex row justify-center align-center">
                        <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img>
                    </v-col>
                    <v-progress-circular indeterminate size="84" width="8" color="white"
                        class="animacion-process ma-5"></v-progress-circular>
                </v-row>
            </v-container>
        </v-overlay>
        <ValidationObserver ref="obs" v-slot="{ invalid, handleSubmit }">
            <v-form name="formSubsidioMatrimonio" @submit.prevent="handleSubmit(iniciarTramite)" v-model="valid"
                ref="formSubsidioMatrimonio">
                <v-card class="custom-card " flat>
                    <v-card-text class="ma-0 pa-0">
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text">
                                INFORMACIÓN SOBRE EL/LA CONYUGE/CONVIENTE
                            </v-card-text>
                        </v-row>
                        <ValidationObserver ref="datosBasicosObserver" v-slot="{ validate, valid }">
                            <v-row class="d-flex flex-column" v-if="familiaresSubsidios.length !== 0">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-col class=" mt-2">
                                        <v-select clearable v-model="familiarSeleccionado" :items="familiaresSubsidios"
                                            return-object chips color="primary" deletable-chips
                                            :error-messages="v.errors[0]"
                                            :item-text="item => `${item.nombres} ${item.apellido} | DNI: ${item.nrodoc}`"
                                            label="Seleccionar familiar" @change="capturarFamiliares"></v-select>
                                    </v-col>
                                </ValidationProvider>
                            </v-row>
                            <v-row class="pt-3" v-if="familiarSeleccionado || (familiaresSubsidios.length == 0)">
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="familiar.pmt_nombreCony" label="Nombres"
                                            :error-messages="v.errors[0]"
                                            :disabled="(familiarSeleccionado !== null) || (infoFamiliar)"
                                            @input="familiar.pmt_nombreCony = familiar.pmt_nombreCony.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces" v-slot="v">
                                        <v-text-field dense v-model="familiar.pmt_apellidoCony" type="text"
                                            label="Apellido" :error-messages="v.errors[0]"
                                            :disabled="(familiarSeleccionado !== null) || (infoFamiliar)"
                                            @input="familiar.pmt_apellidoCony = familiar.pmt_apellidoCony.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="8" md="6">
                                    <ValidationProvider rules="required|minmax:7,8|numeric" v-slot="v">
                                        <v-text-field dense v-model="familiar.pmt_dniCony" type="number"
                                            hide-spin-buttons @input="familiar.pmt_dniCony = familiar.pmt_dniCony"
                                            label="Nro. DNI"
                                            :disabled="(familiarSeleccionado !== null) || (infoFamiliar)"
                                            :error-messages="v.errors[0]" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="4" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="familiar.pmt_sexo" :items="itemSexo" label="Sexo"
                                            :error-messages="v.errors[0]"
                                            :disabled="(familiarSeleccionado !== null) || (infoFamiliar)">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-autocomplete dense v-model="familiarOriginal.nacionalidad"
                                            @input="selectNacionalidad" return-object :items="nacionalidades"
                                            item-value="id" item-text="desnacionalidad" label="Nacionalidad"
                                            :disabled="(familiarSeleccionado !== null) || (infoFamiliar)"
                                            :error-messages="v.errors[0]">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-select dense v-model="familiarOriginal.tipnacionalidad"
                                            :error-messages="v.errors[0]"
                                            :disabled="(familiarSeleccionado !== null) || (infoFamiliar)"
                                            @input="selectTipNacionalidad" :items="tipoNacionalidad" item-value="tna_id"
                                            return-object item-text="tna_destipnac" label="Tipo de nacionalidad">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required|menoranios:100" v-slot="v">
                                        <v-text-field v-model="familiar.pmt_fechaNacCony" dense
                                            label="Fecha de nacimiento:" type="date" :error-messages="v.errors[0]"
                                            :disabled="(infoFamiliar)"></v-text-field>
                                        <!--  :disabled="(((familiarSeleccionado !== null) || (infoFamiliar)) && familiarSeleccionado.fecnacim !== '1900-01-01')"></v-text-field> -->
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field v-model="afiliado.pmt_fechaMatrimonio" dense ref="campoDestino"
                                            label="Fecha de matrimonio/unión convencial:" type="date"
                                            :disabled="(infoFamiliar)" :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoFamiliar" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInformacionFam">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR INFORMACIÓN
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :loading="loadBtn"
                                        :disabled="!valid" @click="validarSubsidio">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR INFORMACIÓN
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row class="d-flex flex-row justify-center align-center">
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                CUENTA DE ACREDITACIÓN
                            </v-card-text>
                        </v-row>
                        <!-- <v-form ref="formValidarCuenta" v-model="validCuenta" @submit.prevent="validarCbu"> -->
                        <ValidationObserver ref="datosCuentaObserver" v-slot="{ validate, valid }">

                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-alert colored-border color="orange darken-3" border="left" elevation="0" dense
                                        class="rounded-0 font-weight-regular text-body-1 orange--text text--darken-3">
                                        Recordá que debés ser titular de la cuenta
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-if="mediosPagos.length !== 0">
                                <v-col cols="12" md="12">
                                    <v-select v-model="medioSeleccionado" label="Seleccione cuenta" return-object
                                        clearable chips deletable-chips
                                        :item-text="item => `CBU: ${item.deb_cbu1}${item.deb_cbu2}`"
                                        :items="mediosPagos" @change="capturarCuenta"></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pmt_nomYApeTitular"
                                            :readonly="(nombreApellido !== '')" type="text" hide-spin-buttons
                                            :disabled="infoCuenta" label="Titular" :error-messages="v.errors"
                                            @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:22|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pmt_cbu" type="number" hide-spin-buttons
                                            label="CBU" :error-messages="v.errors" @keydown="preventArrowKeys"
                                            :disabled="infoCuenta">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider rules="required|length:11|numeric" v-slot="v">
                                        <v-text-field dense v-model="afiliado.pmt_cuit" :readonly="(user.cuil !== '')"
                                            :disabled="infoCuenta" type="number" hide-spin-buttons label="CUIT/CUIL"
                                            :error-messages="v.errors" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col md="12" cols="12">
                                    <v-text-field v-model="entidadBancaria" label="Entidad bancaria" readonly>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn v-if="infoCuenta" color="primary" elevation="0" class="pa-5"
                                        :loading="loadBtn" @click="habilitarInfoCuenta">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>
                                        MODIFICAR CUENTA
                                    </v-btn>
                                    <v-btn v-else color="primary" elevation="0" class="pa-5" :disabled="!valid"
                                        :loading="loadBtnCuenta" @click="validarCbu">
                                        <v-icon class="mr-2">mdi-information</v-icon>
                                        VALIDAR CUENTA
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </ValidationObserver>
                        <v-row>
                            <v-col>
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-card-text class="font-weight-bold text-body-1 black--text ">
                                DOCUMENTACIÓN REQUERIDA:
                            </v-card-text>
                        </v-row>
                        <v-row class="d-flex flex-row align-end justify-start"
                            :class="($vuetify.breakpoint.smAndDown) ? 'justify-center' : 'justify-space-around'">
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="sentenciaAdopcion"
                                :label="(tipo == 'unionconvivencial') ? 'ACTA DE UNIÓN CONVIVENCIAL' : 'ACTA DE MATRIMONIO'" />
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="comprobanteCbu"
                                label="COMPROBANTE DE CBU" />
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="dniFrenteFamiliar"
                                label="DNI CÓNYUGE FRENTE" />
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="dniDorsoFamiliar"
                                label="DNI CÓNYUGE DORSO" />
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end align-center custom-card-actions-ha">
                        <v-btn color="primary" elevation="0" class="pa-5"
                            :disabled="invalid || !formValid || !(infoCuenta && infoFamiliar)" type="iniciarTramite">
                            <v-icon class="mr-2">mdi-send-outline</v-icon>
                            enviar trámite
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>

import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import DialogoComDistrito from '@/components/dialogos/DialogoComDistrito.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        InputButtonArchivo,
        DialogoComDistrito
    },
    mounted() {
        //this.afiliado.pad_remitirADistrito = this.user.distrito
        this.afiliado.pmt_nroafi = this.nroafi
        this.afiliado.pmt_nomYApeTitular = this.nombreApellido
        if (this.user.cuil) (
            this.afiliado.pmt_cuit = this.user.cuil
        )
        if (this.tipo == 'matrimonio') {
            this.familiarOriginal.estadocivil = 2 // casado
            this.familiarOriginal.tipfamiliar = 1 // conyuge
            this.afiliado.pmt_observaciones = "Matrimonio"
        } else {
            this.familiarOriginal.estadocivil = 9 // union-convivencial
            this.familiarOriginal.tipfamiliar = 2 //conviviente
            this.afiliado.pmt_observaciones = "Unión Convivencial"

        }

        //this.getBancos()
        /*         this.afiliado.pad_cuit = this.user.cuil */
    },
    data() {
        return {
            dniOriginal: '',
            loading: false,
            titulo: '',
            tipo: '',
            width: '',
            icon: '',
            itemSexo: ['F', 'M', 'X'], // item select sexo
            selectedBancoCod: '',
            isValidSub: '',


            familiar:
            {
                pmt_nombreCony: '',
                pmt_apellidoCony: '',
                pmt_fechaNacCony: '',
                pmt_dniCony: '',
                pmt_tipodoc: '1',
                pmt_sexo: '',
            },
            afiliado:
            {
                pmt_nroafi: "",
                pmt_fechaMatrimonio: "",
                pmt_fechaSentencia: "",
                pmt_nomYApeTitular: "",
                pmt_cbu: "",
                pmt_cuit: "",
                pmt_observaciones: "",
            },
            familiarOriginal: {
                id: '',
                nroafi: "",
                nombres: "",
                apellido: '',
                sexo: "",
                tipdoc: 1,
                nrodoc: "",
                estadocivil: '',
                nacionalidad: '',
                tipnacionalidad: '',
                tipfamiliar: '',
                fecnacim: "",
                fecfallecido: "",
                fecestadocivil: "",
                discapacidad: "",
                accion: "A"
            },
            ordenClaves: ['id', 'nroafi', 'apellido', 'nombres', 'sexo', 'tipdoc', 'nrodoc', 'estadocivil', 'nacionalidad', 'tipnacionalidad', 'tipfamiliar', 'fecnacim', 'fecfallecido', 'fecestadocivil', 'discapacidad', 'accion'],
            formValid: false,
            familiarSeleccionado: null,
            medioSeleccionado: null,

            infoFamiliar: false,
            infoCuenta: false,

            loadBtn: false,
            loadBtnCuenta: false,
        }
    },

    methods: {
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('subsidios', ['solicitarSubsidiosMatrimonio', 'validarSubsidioAfiliado']),
        ...mapActions('mediosDePago', ['validarCBU', 'blanquearEntidad']),

        //calcula condicion de fecha para poder realizar el tramite
        calculateDate(fecha) {
            const month = 12
            const fechaInicio = new Date(fecha)
            const totalMeses = (new Date().getFullYear() - fechaInicio.getFullYear()) * month +
                (new Date().getMonth() - fechaInicio.getMonth())
            return (totalMeses >= month)
        },

        habilitarInformacionFam() {
            this.infoFamiliar = false
        },
        habilitarInfoCuenta() {
            this.infoCuenta = false
        },
        selectTipNacionalidad(value) {
            this.familiarOriginal.tipnacionalidad = value.tna_id
        },
        selectNacionalidad(value) {
            this.familiarOriginal.nacionalidad = value.id
            this.familiarOriginal.desnacionalidad = value.desnacionalidad
        },

        // Captura familiar al seleccionarlo del item para mostrarlo en el formulario
        capturarFamiliares(item) {
            //            this.infoFamiliar = false;
            // Configura los valores de 'familiar' y 'afiliado' o los deja en blanco si item está vacío
            Object.assign(this.familiar, {
                pmt_nombreCony: item?.nombres || '',
                pmt_apellidoCony: item?.apellido || '',
                pmt_fechaNacCony: item?.fecnacim || '',
                pmt_dniCony: item?.nrodoc || '',
                pmt_sexo: item?.sexo || ''
            });
            // this.familiarOriginal
            this.dniOriginal = item?.nrodoc || '';
            this.afiliado.pmt_fechaMatrimonio = item?.fecestadocivil || '';
            // Enfoca el campo al seleccionar un familiar
            if (item) {
                this.$nextTick(() => {
                    if (this.$refs.campoDestino) {
                        this.$refs.campoDestino.focus();
                    }
                });
            }
            // Llama a la función que almacena en familiarOriginal el objeto
            this.cargarFamiliarOriginal(item || '');

            //cuando no hay familiarSeleccionado vuelve a poner en false infoFamiliar
            if (item == null) this.infoFamiliar = false
        },

        // Copia los datos del objeto recibido en familiarOriginal para poder insertar
        cargarFamiliarOriginal(item) {
            if (item !== '') {
                this.familiarOriginal.accion = "M";
            } else {
                this.familiarOriginal.accion = "A";
            }
            Object.assign(this.familiarOriginal, {
                id: item.id,
                nroafi: item.nroafi,
                nombres: item.nombres,
                apellido: item.apellido,
                sexo: item.sexo,
                tipfamiliar: 1,
                nrodoc: item.nrodoc,
                nacionalidad: item.nacionalidad,
                tipnacionalidad: item.tipnacionalidad,
                estadocivil: item.estadocivil,
                fecfallecido: item.fecfallecido,
                discapacidad: item.discapacidad
            });
        },

        async validarSubsidio() {
            this.loadBtn = true
            const obj = {
                nroafi: this.nroafi,
                tipoSubsidio: 'matrimonio',
                fechaNacimiento: this.familiar.pmt_fechaNacCony,
                dniFamiliar: this.familiar.pmt_dniCony,
                fechaSentencia: '',
                fechaMatrimonio: this.afiliado.pmt_fechaMatrimonio
            };
            const resultado = await this.validarSubsidioAfiliado(obj);
            if (!resultado) {
                this.$refs.dialogoCom.abrirDialog()
            } else {

                this.infoFamiliar = true

                // en la validacion actualizo los datos de las fechas
                //  que quiero mandar en el objeto familiarOriginal
                this.familiarOriginal.fecnacim = this.familiar.pmt_fechaNacCony
                this.familiarOriginal.fecestadocivil = this.afiliado.pmt_fechaMatrimonio
            }
            this.loadBtn = false; // Desactivamos el loading al finalizar
        },
        async validarCbu() {
            this.loadBtnCuenta = true
            const resultado = await this.validarCBU({ cbu: this.afiliado.pmt_cbu })
            if (resultado) this.infoCuenta = true
            this.loadBtnCuenta = false; // Desactivamos el loading al finalizar
        },
        handleFileSelected() {
            (this.sentenciaAdopcion.length !== 0) && (this.comprobanteCbu.length !== 0) && (this.dniFrenteFamiliar.length !== 0) && (this.dniDorsoFamiliar.length !== 0) ? this.formValid = true : this.formValid = false
        },
        obtenerFamiliarOrdenado() {
            const familiarOrdenado = {};
            this.ordenClaves.forEach(key => {
                familiarOrdenado[key] = this.familiarOriginal[key];
            });
            return familiarOrdenado;
        },

        capturarCuenta(item) {
            //this.infoCuenta = false
            this.afiliado.pmt_nomYApeTitular = this.nombreApellido
            this.afiliado.pmt_cuit = this.user.cuil
            if (item) {
                this.afiliado.pmt_cbu = `${item.deb_cbu1}${item.deb_cbu2}`
            } else {
                this.afiliado.pmt_cbu = ''
                this.blanquearEntidad()
                this.infoCuenta = false
            }
        },
        formatDate(date) {
            if (!date) return null
            if (date.includes('/')) {
                const [year, month, day] = date.split('/')
                return `${day}-${month}-${year}`
            } else {
                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        },
        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },

        /* 
                if (this.tipo == 'matrimonio') {
                    this.familiarOriginal.estadocivil = 2 // casado
                    this.familiarOriginal.tipfamiliar = 1 // conyuge
                } else {
                    this.familiarOriginal.estadocivil = 9 // union-convivencial
                    this.familiarOriginal.tipfamiliar = 2 //conviviente
        
                }
        */

        async iniciarTramite() {
            try {
                this.loading = true

                // valida los datos del formulario
                const result = this.$refs.obs.validate()


                //Si el conyuge/conviviente es nuevo seteo el familiar con id: 0 y las claves correspondientes para insertar
                if (this.familiarOriginal.accion == "A") {
                    this.familiarOriginal = {
                        id: 0,
                        nroafi: this.afiliado?.pmt_nroafi || "",
                        apellido: this.familiar?.pmt_apellidoCony || "",
                        nombres: this.familiar?.pmt_nombreCony || "",
                        sexo: this.familiar?.pmt_sexo || "",
                        tipdoc: this.familiar?.pmt_tipodoc || 1,
                        nrodoc: this.familiar?.pmt_dniCony || "",
                        estadocivil: this.familiarOriginal.estadocivil,
                        nacionalidad: this.familiarOriginal.nacionalidad, // Asignar valor si está disponible
                        tipnacionalidad: this.familiarOriginal.tipnacionalidad, // Asignar valor si está disponible
                        tipfamiliar: this.familiarOriginal.tipfamiliar, // Asignar valor si está disponible
                        fecnacim: this.familiar?.pmt_fechaNacCony || "",
                        fecfallecido: "", // Asignar valor si está disponible
                        fecestadocivil: this.afiliado?.pmt_fechaMatrimonio || "",
                        discapacidad: "", // Asignar valor si está disponible
                        accion: "A", // Asignar valor si está disponible
                    };
                }
                if (result) {
                    //this.copiarClaves()
                    console.log(this.familiar)
                    console.log(this.familiarOriginal)
                    const datosOrdenados = this.obtenerFamiliarOrdenado()
                    const formData = new FormData()
                    formData.append('afiliado', JSON.stringify(this.afiliado))
                    formData.append('familiar', JSON.stringify(this.familiar))
                    //familiarOriginal array de object
                    formData.append('familiarOriginal', JSON.stringify([datosOrdenados]))
                    formData.append('archivo1', this.sentenciaAdopcion[0])
                    formData.append('archivo2', this.comprobanteCbu[0])
                    formData.append('archivo3', this.dniFrenteFamiliar[0])
                    formData.append('archivo4', this.dniDorsoFamiliar[0])
                    formData.forEach((value, key) => {
                        console.log(`Campo: ${key}, Valor:`, value);
                    });
                    await this.solicitarSubsidiosMatrimonio(formData)
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            } catch (error) {
                console.error("Ocurrió un error durante el proceso:", error);
            } finally {
                this.loading = false
                this.$emit('handleDialog')
            }
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
    },
    computed: {
        ...mapGetters('dataUser', ['sentenciaAdopcion', 'comprobanteCbu', 'dniDorsoFamiliar', 'dniFrenteFamiliar']),
        ...mapGetters('subsidios', ['familiaresSubsidios', 'mediosPagos', 'validSub']),
        ...mapGetters('auth', ['user', 'nroafi', 'isAuthenticated']),
        ...mapGetters('mediosDePago', ['bancos', 'codigoBanco', 'entidadBancaria']),
        ...mapGetters('common', ['tipoNacionalidad', 'estadoCivil', 'tiposFamiliares', 'nacionalidades']),

        nombreApellido() {
            return `${this.user.nombres} ${this.user.apellido}`
        }
    },
    props: ['tipo']

}
</script>

<style>
/* Aplicamos el estilo para ajustar el tamaño del texto */
.v-list-item__subtitle {
    white-space: normal;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.custom-card-actions-ha {
    position: fixed;
    /* Fijo en la parte inferior */
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    /* Ajusta la altura según sea necesario */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    /* Asegúrate de que esté por encima del contenido */
}
</style>